import { render } from "./UserActionInvalid.vue?vue&type=template&id=715e3fcb&scoped=true&ts=true"
import script from "./UserActionInvalid.vue?vue&type=script&lang=ts"
export * from "./UserActionInvalid.vue?vue&type=script&lang=ts"

import "./UserActionInvalid.vue?vue&type=style&index=0&id=715e3fcb&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715e3fcb"]])

export default __exports__